export const LISTEN_SOCKET_MESSAGE_EVENT_NAME = 'message';
